// import 'owl.carousel';
import 'jquery.validation';
import 'slick-carousel';
// import swal from 'sweetalert';
import * as Slideout from 'slideout';
import './elementor/post-widget';
import './elementor/tabs-widget';

$('document').ready(function ($){
	let slideout = new Slideout({
		'panel': document.getElementById('panel'),
		'menu': document.getElementById('menuSliderOut'),
		'padding': 256,
		'tolerance': 70,
		'easing': 'cubic-bezier(.32,2,.55,.27)',
		'touch': false,
		'side': 'right'
	});
	$('#menuSliderOut .menu-main-m').show();
	$('#menuSliderOutButton').on('click', function () {
		slideout.toggle();
	});

	$('.menu-main-m .menu-item-has-children > a').click(function (e){
		e.preventDefault();
		$(this).parent().toggleClass('show');
	});

	if( $('.slick-slider').length ){
		$( '.slick-slider' ).not( '.slick-initialized' ).slick( {
			infinite: true,
			lazyLoad: 'ondemand',
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						dots: false,
						arrows: true
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						dots: false,
						arrows: true
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: true,
						dots: false
					}
				}
			]
		} );
	}
});